// extracted by mini-css-extract-plugin
export default {"wrapper":"PrimeContainer_wrapper__vvS8B","iconContainer":"PrimeContainer_iconContainer__F7cu6","tagContainer":"PrimeContainer_tagContainer__1sqwr"};